import OfflineAppMain from './OfflineAppMain';

export default OfflineAppMain;
